export default function Button({ params }) {
  const { text, url } = params;
  return (
    <>
      <a target="_blank" className="ob-btn" href={url}>
        <span
          dangerouslySetInnerHTML={{
            __html: text,
          }}
        ></span>
      </a>
    </>
  );
}
